
                {
                    const el = document.createElement("style");
                    el.textContent = "\n.manual-button__button {\n  border: none;\n  background: none;\n  font-size: 80%;\n  text-decoration: underline;\n  cursor: pointer;\n}\n";
                    document.head.append(el);
                }